module.exports = __webpack_public_path__ + "img/huwelijksdrukwerk-drukwerk-annonce-trouwen-anna-marcelo-goudfolie-foliedruk-italian-wedding-3.bd2f2e22.jpg";